import { render } from "./ParameterSelection.vue?vue&type=template&id=2c1ea212&scoped=true"
import script from "./ParameterSelection.vue?vue&type=script&lang=js"
export * from "./ParameterSelection.vue?vue&type=script&lang=js"

import "./ParameterSelection.vue?vue&type=style&index=0&id=2c1ea212&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1ea212"]])

export default __exports__